import { createSelector } from 'reselect';
import {
  getParentCategories,
  getCategories,
} from './basicData';

const getCategoriesWithParents = (parentCategories, categories) => ({
  parentCategories,
  categories: Object.keys(categories).reduce(
    (acc, cat) => acc.concat({ ...categories[cat], key: cat }),
    []
  ),
});

const getCategoriesWithParentsSelector = createSelector(
  [getParentCategories, getCategories],
  getCategoriesWithParents,
);

export default getCategoriesWithParentsSelector;

export { getCategoriesWithParents };



// WEBPACK FOOTER //
// ./app/selectors/getCategoriesWithParents.js